import Vue from "vue";
import Router from "vue-router";
import store from '../src/store/store.js'
import VueMeta from 'vue-meta'
import RestaurantStorage from '../src/storage/restaurants.js'
import CartStorage from '../src/storage/cart.js'

import openingHours from './middlewares/openingHours.js'
import { trackMetaPageView } from "./analytics/metaPixel";

Vue.use(Router);
Vue.use(VueMeta)

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import("./views/Home.vue")
    },
    {
      path: "",
      component: () => import("./layouts/Default.vue"),
      children: [
        {
          path: "/restaurants",
          name: "restaurants",
          component: () => import("./views/restaurants/RestaurantsView.vue")
        },
        {
          path: "/about",
          name: "about",
          component: () => import("./views/About.vue")
        },
        {
          path: "/menu",
          name: "menu",
          component: () => import("./views/menus/MenuView.vue")
        },
        {
          path: "/productguide",
          name: "productguide",
          component: () => import("./views/guide/ProductGuideNew.vue")
        },
        {
          path: "/contact",
          name: "contact",
          component: () => import("./views/Contact.vue")
        },
        {
          path: "/faqs",
          name: "faqs",
          component: () => import("./views/faq/FaqsView.vue")
        },
        
        {
          path: "/profile",
          name: "profile",
          component: () => import("./views/userAccount/UserPage.vue")
        }
      ]
    },
    {
      path: "",
      component: () => import("./layouts/Checkout.vue"),
      children : [
        {
          path: "/checkoutaccept",
          name: "checkoutaccept",
          component: () => import("./views/checkout/CheckoutSuccess.vue")
        },
        {
          path: "/payment",
          name: "payment",
          component: () => import("./views/checkout/PaymentViewRedirect.vue"),
          beforeEnter: (to, from, next) => {
            if (to.query.paymentId === null || to.query.paymentId === '') {
              next({
                path: '/',
                params: { nextUrl : to.fullPath }
              })
            }
            else {
              next();
            }
          }
        },
        {
          path: "/checkoutcancel",
          name: "checkoutcancel",
          component: () => import("./views/checkout/CheckoutCancel.vue")
        },
        {
          path: "/checkout",
          name: "checkout",
          component: () => import("./views/checkout/CheckoutView.vue"),
          beforeEnter: (to, from, next) => {
            if (store.state.cart.selectedItems.length === 0) {
              next({
                path: '/',
                params: { nextUrl : to.fullPath }
              })
            }
            else {
              next();
            }
          },
        },
        {
          path: "/terms",
          name: "terms",
          component: () => import("./views/TermsOfUse.vue"),
          beforeEnter: (to, from, next) => {
            if (store.state.restaurants.currentRestaurantId === null) {
              next({
                path : '/',
                params: { nextUrl : to.fullPath }
              })
            }
            else {
              next();
            }
          },
        },
      ]
    },

    {
      path: "",
      component: () => import("./layouts/FullPage.vue"),
      children: [
        {
          path: "/exception:status",
          name: "exception",
          component: () => import("./pages/Exception.vue"),
          props : true
        },
        {
          path: "/timeout",
          name: "timeout",
          component: () => import("./pages/ClientTimeout.vue")
        },
        {
          path: "/notfound",
          name: "notfound",
          component: () => import("./pages/NotFound.vue")
        },
      ]
    },
    {
      path: "*",
      name: "404",
      component: () => import("./pages/Error404.vue")
    }
  ]
});

let skipFirstMetaPageView = true;
router.afterEach(() => {
  if (skipFirstMetaPageView) {
    skipFirstMetaPageView = false;
    return;
  }
  trackMetaPageView();
});

export default router;
